import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom';
import Sidebarapp from './Components/Sidebarapp';
import Form from './Components/Form';
import DeriverDetail from './Components/Pages/Driver/DeriverDetail';
import Driver from './Components/Pages/Driver/Driver';
import DriverDocumentsPanel from './Components/Pages/DriverDocumentsPanel';
import DocumentList from './Components/DocumentList';
import Login from './Components/Pages/login/login';
import Register from './Components/Pages/login/Register';
import Unauthorized from './Unauthorized';
import ProtectedRoute from './ProtectedRoute';
import RoleRoute from './RoleRoute';
import EmployeeDashboard from './EmployeeDashboard';
import AdminDashboard from './AdminDashboard';
import VehicleFareList from './Components/VehicleFareList';

function App() {
  const [driver, setDriver] = useState(null);
  return (
//     <Router>
// <Register />

//       <Sidebarapp />
//       <Login />
//       <Routes>
//         {/* <Route path="/" element={<Form />} /> */}
//         {/* <Route path="/driver" element={<Driver/>} /> */}
//         <Route path="/driverdetail" element={<DriverDocumentsPanel  onBack={() => setDriver(null)} />} />
//              <Route path="/documentlist/:id" element={<DocumentList   />} />

//       </Routes>
//     </Router>
  

 <BrowserRouter>
  {/* <VehicleFareList /> */}
      <Routes>

        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/unauthorized" element={<Unauthorized />} />


 <Route path="/driverdetail" element={<DriverDocumentsPanel  onBack={() => setDriver(null)} />} />
              <Route path="/documentlist/:id" element={<ProtectedRoute><DocumentList   /></ProtectedRoute>} />
        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>

             

              <RoleRoute role="admin">
                {/* <AdminDashboard /> */}
                <Sidebarapp />
              </RoleRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <RoleRoute role="employee">
                <EmployeeDashboard />
              </RoleRoute>
            </ProtectedRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
